import React, { useState, useEffect } from "react";
import { useTable, useFilters, usePagination, useSortBy } from "react-table";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import { RiTableFill, RiTableLine } from "react-icons/ri";
import { PiCalendarDotsFill, PiCalendarDots } from "react-icons/pi";
import CalendarView from "../components/Control/CalendarView";
import LOADER from "../assets/images/loader.svg";
import { getControls_Report, editControl, getControls_Search } from "../store/actions/riskActions";
import Popup from 'reactjs-popup';
import ControlOverlay from "../components/Control/ControlOverlay";
import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";


function AllControls(props) {
    const { token, controls, activeDepartmentId, getControlsReportFN, getControlsSearchFN, editControlFN } = props;

    const [loading, setLoading] = useState(false);
    const [flattenedControls, setFlattenedControls] = useState([]);
    const [selectedView, setSelectedView] = useState("table");
    const [isControlOpen, setIsControlOpen] = useState(false);
    const [control_id, setControlId] = useState(null);
    const [risk_id, setRiskId] = useState(null);



    useEffect(() => {
        console.log(activeDepartmentId)
        if (activeDepartmentId === null) {
            setLoading(true);
            getControlsSearchFN(null).finally(() => setLoading(false));
            //console.log(controls);
        }
    }, [activeDepartmentId, getControlsSearchFN]);

    useEffect(() => {
        if (controls && controls?.length > 0) {
            //console.log("Controls before flat:" , controls);
            const allControls = controls
                .filter((control) =>
                    control.controls.some(
                        (c) =>
                            c.controlDetails !== null ||
                            c.controlType !== null ||
                            c.controlDefinition !== null
                    )

                )
                .flatMap((control) =>
                    control.controls.map((c) => ({
                        ...c,
                        riskId: control.riskId,
                        title: control.title,
                        owner: c.owner,
                        is_secondline: c.secondline
                    }))
                );
            setFlattenedControls(allControls);
        } else {
            setFlattenedControls([]);
        }
    }, [controls]);

    const closeCreation = async (data, control_id) => {
        console.log("Data:", data, "ID", control_id)

        setIsControlOpen(false)
        await updateServerData(data, control_id);
        getControlsSearchFN(null)

    }

    const updateServerData = async (data, control_id) => {


        const updatedData = { ...data };

        // Add one day to StartDate and EndDate if they exist
        if (updatedData.StartDate) {
            const startDate = new Date(updatedData.StartDate);
            startDate.setDate(startDate.getDate() + 1);
            updatedData.StartDate = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        if (updatedData.EndDate) {
            const endDate = new Date(updatedData.EndDate);
            endDate.setDate(endDate.getDate() + 1);
            updatedData.EndDate = endDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        //console.log("CONTROL DATA AFTER ADJUSTMENT", updatedData);

        setLoading(true);
        await editControlFN(risk_id, control_id, updatedData);
        setLoading(false);

    }

    const compliancePillClass = (t) => {
        const map = {
            "NIST": "bg-blue-100 text-blue-800 border-blue-300",
            "COBIT": "bg-purple-100 text-purple-800 border-purple-300",
            "ISO 27001": "bg-emerald-100 text-emerald-800 border-emerald-300",
            "GDPR": "bg-amber-100 text-amber-900 border-amber-300",
        };
        return map[t] || "bg-gray-100 text-gray-800 border-gray-300";
    };

    const columns = React.useMemo(
        () => [
            {
                Header: "Control Title",
                accessor: "controlDetails",
                Cell: ({ value }) => (
                    <div style={{ whiteSpace: "normal", wordWrap: "break-word", width: "400px" }}>
                        {value}
                    </div>
                ),
            },
            {
                Header: "Compliance Types",
                accessor: "complianceTypes",
                Cell: ({ value }) => (
                    <div className="flex flex-wrap gap-1">
                        {Array.isArray(value) && value.length > 0
                            ? value.map((c, i) => (
                                <span
                                    key={i}
                                    className={`px-2 py-0.5 text-xs rounded border ${compliancePillClass(c)}`}
                                >
                                    {c}
                                </span>
                            ))
                            : <span className="text-gray-400 text-xs">None</span>}
                    </div>
                ),
            },
            { Header: "Control Type", accessor: "controlType" },
            {
                Header: "Control Efficiency",
                accessor: "efficiencyLevel",
                Cell: ({ value }) => (
                    <div className="relative w-32 h-6 bg-gray-200 rounded-full flex items-center">
                        <div
                            className="absolute h-full rounded-full"
                            style={{
                                width: `${value || 0}%`,
                                backgroundColor:
                                    value >= 75 ? "#00AFB9" : value >= 50 ? "#FFD166" : "#EF476F",
                            }}
                        />
                        <span className="relative text-white ml-2 text-xs">
                            {value ? `${parseFloat(value).toFixed(0)}%` : "0%"}
                        </span>
                    </div>
                ),
            },
            { Header: "Control Period", accessor: "controlPeriod" },
            { Header: "Risk Title", accessor: "title" },
            {
                Header: "Owner",
                accessor: (row) =>
                    `${row.owner?.firstName || ""} ${row.owner?.lastName || ""}`,
                id: "owner",
            },
        ],
        []
    );

    //console.log("flattened controls:", flattenedControls);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        nextPage,
        previousPage,
        gotoPage,
        setPageSize,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data: flattenedControls,
            initialState: { pageIndex: 0, pageSize: 10 },
            autoResetPage: false,
            autoResetSortBy: false,
            autoResetFilters: false,
        },
        useFilters,
        useSortBy,
        usePagination
    );

    const renderPagination = () => (
        <div className="pagination flex justify-center items-center mt-4">
            <div className="flex items-center space-x-2">
                <button
                    onClick={() => gotoPage(0)}
                    disabled={!canPreviousPage}
                    className={`pagination-button ${!canPreviousPage ? "disabled" : ""}`}
                >
                    « First
                </button>
                <button
                    onClick={() => previousPage()}
                    disabled={!canPreviousPage}
                    className={`pagination-button ${!canPreviousPage ? "disabled" : ""}`}
                >
                    ‹ Prev
                </button>
                <span>
                    Page <strong>{pageIndex + 1}</strong> of{" "}
                    <strong>{Math.ceil(flattenedControls?.length / pageSize) || 1}</strong>
                </span>
                <button
                    onClick={() => nextPage()}
                    disabled={!canNextPage}
                    className={`pagination-button ${!canNextPage ? "disabled" : ""}`}
                >
                    Next ›
                </button>
                <button
                    onClick={() => gotoPage(Math.ceil(flattenedControls?.length / pageSize) - 1)}
                    disabled={!canNextPage}
                    className={`pagination-button ${!canNextPage ? "disabled" : ""}`}
                >
                    Last »
                </button>
            </div>
            <div className="ml-4">
                <label>
                    Page Size:
                    <select
                        value={pageSize}
                        onChange={(e) => setPageSize(Number(e.target.value))}
                        className="ml-2 border rounded-md p-1"
                    >
                        {[10, 20, 30, 40, 50].map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>
                </label>
            </div>
        </div>
    );

    const handleIconClick = (view) => setSelectedView(view);


    //console.log("RISK ID FOR CONTROL", controls.risk_id);

    return token ? (
        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full overflow-hidden"> {/* Prevent horizontal scrolling */}
                <Sidebar className="fixed top-0 left-0 h-full pt-[64px] z-0" /> {/* Adjust the top to match TopBar height */}
                <div className="controls-container">
                    {loading ? (
                        <img src={LOADER} alt="Loading..." className="spinner" />
                    ) : (
                        <>
                            <div className="flex justify-end mb-8">
                                <div className="absolute top-46 right-14 flex space-x-4">
                                    <button
                                        onClick={() => handleIconClick("table")}
                                        className={`border px-4 py-2 bg-[#F8F8F8] hover:bg-gray-100 rounded ${selectedView === "table" ? "text-[#3b3b3b]" : "text-gray-500"
                                            }`}
                                    >
                                        {selectedView === "table" ? <RiTableFill size={16} /> : <RiTableLine size={16} />}
                                    </button>
                                    <button
                                        onClick={() => handleIconClick("calendar")}
                                        className={`border px-4 py-2 bg-[#F8F8F8] hover:bg-gray-100 rounded ${selectedView === "calendar" ? "text-[#3b3b3b]" : "text-gray-500"
                                            }`}
                                    >
                                        {selectedView === "calendar" ? (
                                            <PiCalendarDotsFill size={16} />
                                        ) : (
                                            <PiCalendarDots size={16} />
                                        )}
                                    </button>
                                </div>
                            </div>
                            {selectedView === "table" ? (
                                <>
                                    <div className="table-wrapper mr-10 ml-10 shadow-xl" style={{ marginTop: "32px" }}>
                                        <table {...getTableProps()} className="main-table shadow-xl">
                                            <thead>
                                                {headerGroups.map((headerGroup) => (
                                                    <tr
                                                        {...headerGroup.getHeaderGroupProps()}
                                                        className="border-b border-gray-300"
                                                    >
                                                        {headerGroup.headers.map((column) => (
                                                            <th
                                                                {...column.getHeaderProps(column.getSortByToggleProps())}
                                                                className="cursor-pointer px-4 py-2"
                                                            >
                                                                <div className="flex items-center">
                                                                    {column.render("Header")}
                                                                    <span>
                                                                        {column.isSorted
                                                                            ? column.isSortedDesc
                                                                                ? " 🔽"
                                                                                : " 🔼"
                                                                            : ""}
                                                                    </span>
                                                                </div>
                                                            </th>
                                                        ))}
                                                        {/* keep this so header spans the full width */}
                                                        <th className="w-[40px]"></th>
                                                    </tr>
                                                ))}
                                            </thead>

                                            <tbody {...getTableBodyProps()}>
                                                {page.map((row) => {
                                                    prepareRow(row);
                                                    return (
                                                        <tr
                                                            {...row.getRowProps({
                                                                onClick: () => {
                                                                    const matchingRisk = controls.find(risk =>
                                                                        risk.controls.some(ctrl => ctrl.controlID === row.original.controlID)
                                                                    );
                                                                    if (matchingRisk) setRiskId(matchingRisk.riskId);
                                                                    setControlId(row.original.controlID);
                                                                    setTimeout(() => setIsControlOpen(true), 0);
                                                                }
                                                            })}
                                                            className="group transition-colors duration-200 cursor-pointer"
                                                        >
                                                            {row.cells.map((cell) => (
                                                                <td
                                                                    {...cell.getCellProps()}
                                                                    className="overflow-hidden text-ellipsis whitespace-normal border-t border-gray-200 px-4 py-2 group-hover:bg-[#F8F8F8]"
                                                                >
                                                                    {cell.render("Cell")}
                                                                </td>
                                                            ))}

                                                            {/* add trailing td so body rows align with header */}
                                                            <td className="border-t border-gray-200 w-[40px] group-hover:bg-[#F8F8F8]"></td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                    {renderPagination()}
                                </>
                            ) : (
                                <div className="mt-12">
                                    <CalendarView events={flattenedControls} />
                                </div>
                            )}
                        </>
                    )}

                    <Popup
                        open={isControlOpen}
                        onClose={() => setIsControlOpen(false)}
                        contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh' }}
                    >
                        <ControlOverlay key={control_id || 'new-control'} closeControl={closeCreation} control_id={control_id} risk_id={risk_id} />
                    </Popup>


                </div>
            </div>
        </div>
    ) : (
        <Redirect to="/login" />
    );
}

const mapStateToProps = (state) => {
    console.log("Controls:", state.risk.risk_controls)
    return {
        token: state.auth.token,
        controls: state.risk.all_risk_controls,
        activeDepartmentId: state.department.activeDepartmentId,
    }
};

const mapDispatchToProps = (dispatch) => ({
    getControlsReportFN: (departmentId) => dispatch(getControls_Report(departmentId)),
    getControlsSearchFN: (departmentId) => dispatch(getControls_Search(departmentId)),
    editControlFN: (risk_id, control_id, control) => dispatch(editControl(risk_id, control_id, control)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(AllControls);